/** KAN-200 Ship A — pure helpers over a company access level (client UX only; the server enforces). */

/** Office create/change actions are paused (read_only | suspended). */
export const isOfficeLocked = (level) => level === 'read_only' || level === 'suspended';

/** The company is in its grace window (full access, countdown running). */
export const isWarning = (level) => level === 'grace';
